<div class="theme-toggle" (click)="toggleColorScheme()">
  <div class="toggle-slider" [ngClass]="{ light: isActive(ColorScheme.LIGHT), dark: isActive(ColorScheme.DARK) }"></div>
  <button class="option" [class.active]="isActive(ColorScheme.LIGHT)">
    <svg-icon src="/assets/icons/icon-light-mode.svg"></svg-icon>
  </button>
  <button class="option option-dark" [class.active]="isActive(ColorScheme.DARK)">
    <svg-icon src="/assets/icons/icon-dark-mode.svg"></svg-icon>
  </button>
</div>
